export default __webpack_public_path__ + "static/media/bg4.46e071b0.jpg";